import {useQuery} from "react-query";
import {useCreateQueryKey} from "@/lib/hook/useCreateQueryKey";
import {useResponseValidate} from "@/lib/hook/useResponseValidate";
import {api} from "@/lib/api/api";

export const useApi = ({route: {name, query}, data, setting = {}}) => {
    const {
        headers = {},
        namePrefix,
        onError,
        onSuccess,
        queryKey,
        useLocaleKey,
    } = setting

    const key = useCreateQueryKey({
        key: queryKey ? queryKey : name,
        data,
        namePrefix,
        useLocaleKey,
    })

    const {successValidate, errorValidate} = useResponseValidate()

    return useQuery({
        queryKey: key,
        queryFn: async () => {
            return api.send({
                route: {name, query},
                data,
                headers,
            }).then((res) => res.data)
        },
        keepPreviousData: true,
        onError: (error) => {
            errorValidate(error)

            if (onError) {
                onError(error)
            }
        },
        onSuccess: (resp) => {
            successValidate(resp)

            if (onSuccess) {
                onSuccess(resp)
            }
        },
        ...setting,
    });
}
